<template>
  <div>
    <v-row class="pa-5">
      <v-col class="px-3">
        <v-row no-gutters align="center">
          <h5 class="greyBold--text font-weight-bold mb-0">{{$t('common:role_plural')}}</h5>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs}">
              <v-btn class="ml-2" icon @click="cardView = !cardView" v-bind="attrs" v-on="on">
                <v-icon>list_alt</v-icon>
              </v-btn>
            </template>
            <span v-if="cardView">{{ $t('buttons:table-view') }}</span>
            <span v-else>{{ $t('buttons:card-view') }}</span>
          </v-tooltip>
        </v-row>
      </v-col>
      <!-- TODO add search field for cardView -->
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <BaseButton
            color="primary"
            :btn-text="$t('buttons:add-specific', { specific: $t('common:role')})"
            icon="add"
            @clickedButton="$refs.roleForm.openDialog(restRolePaginated.options, restRolePaginated.search)"
        />
      </v-col>
      <v-col cols="12" class="pt-0" v-if="!cardView">          
        <DataTablePaginated
          ref="table"                   
          :headers="roleTableHeaders"
          @updateTableData="updateData"
          sortBy="facilityName"
          @cacheCommit="$store.commit('book/building/storeRolesSearch', $event)"
          :cachedSearch="$store.state.book.building.rolesSearch"
        />
      </v-col>
    </v-row>

    <div v-if="cardView" class="px-5">
      <SearchAndSortBar
        @updateData="updateData"
        @cacheCommit="$store.commit('book/building/storeRolesSearch', $event)"
        :cachedSearch="$store.state.book.building.rolesSearch"
        :sorts="roleTableHeaders"
        disable-filter
        default-sort-by="facilityName"
      />
      <v-row>
        <v-col cols="12" md="6" :lg="cardSize" v-for="(item, i) in restRolePaginated.content" :key="i" >
          <ItemCard
            :item="item"
            :title="item.userName"
            :subtitle="item.roleName"
            :description="$t('common:facility') + ': ' + item.facilityName"
            hideActionBtn1
            hideActionBtn2
            hideActionBtn3
            hideChart
            hideViewBtn
          />
        </v-col>
      </v-row>

      <v-pagination v-if="this.restRolePaginated.content.length != 0"
            v-model="restRolePaginated.options.page"
            :length="totalPages"
            :total-visible="7">
      </v-pagination>
      <h5 v-else-if="this.restRolePaginated.content.length == 0" class="greyTint--text mb-0 mt-5 text-center">{{ $t('common:no-data-found') }}</h5>
  
    </div>
    <!-- Form Dialog for new role-->
    <BuildingUserAssignmentForm
        ref="roleForm"
        @updateRoles="updateData"
    />
  </div>
</template>

<script>

import FacilityUserAssignmentService from "@/modules/book/services/facility-user-assignment-service";

import DataUtils from "@/modules/core/services/data-utils";

import ItemCard from '@/modules/core/components/ItemCard'

import FacilityUserAssignment from "@/modules/book/data/facility-user-assignment";

import DataTablePaginated from "@/modules/core/components/DataTable/DataTablePaginated";

import BuildingUserAssignmentForm from '../BuildingUserAssignmentForm'
import BaseButton from "@/modules/core/components/Base/BaseButton";

import SearchAndSortBar from "@/modules/core/components/SearchAndSortBar";

import {mapState} from 'vuex'

export default {
  name: 'BuildingRoleTab',
  components: {  
    DataTablePaginated,    
    ItemCard,  
    BuildingUserAssignmentForm,
    BaseButton,
    SearchAndSortBar
  },
  data() {
    return {
      cardView: false,
     
      totalPages: null,
     
      restRolePaginated: {
        options: [],
        search: [],
        content: []
      },
    }
  },
  computed: {
    roleTableHeaders() {
      return [
        {text: this.$t("common:facility"), value: "facilityName"},
        {text: this.$t("common:user"), value: "userName"},
        {text: this.$t("common:role"), value: "roleName"},
        {text: this.$t("common:rank"), value: "rank"},
      ]
    },

    cardSize() {
      // if both sidebars are fully opened, make card size bigger
      if(this.leftBuildingDrawer && this.rightBuildingDrawer) {
        return '6'
        // if both side bars are closed, make card size smaller
      } else if(!this.leftBuildingDrawer && !this.rightBuildingDrawer) {
        return '3'
      } else {
        return '4'
      }
    },

    ...mapState('book/layout', {
      leftBuildingDrawer: state => state.leftBuildingDrawer,
      rightBuildingDrawer: state => state.rightBuildingDrawer
    }),
  },
  methods: {
    updateData(options, search) {    
      
      this.restRolePaginated.options = options;
      this.restRolePaginated.search = search;

      if(!search) search = '';
      
      if(!this.cardView) {
        this.$refs.table.loading = true;
      }
      
      FacilityUserAssignmentService.readFacilityUserAssignmentsForBuildingPaginated(this.$route.params.id,
        options.page - 1,
        options.itemsPerPage,
        search,
        ['f.name'],
        options.sortDesc,
        (res) => {
          if(this.cardView) {

            this.restRolePaginated.content = DataUtils.parseDataToObjectArray(res.data.content, FacilityUserAssignment);
                        
            this.totalPages = res.data.totalPages;             
           
          } else {           
            this.$refs.table.fillTableData(res.data);
          }                   
        }          
      )                     
    },
    openDialog() {
      this.$refs.roleForm.openDialog(this.restRolePaginated.options, this.restRolePaginated.search);
    }
  }
}
</script>
